export default __webpack_public_path__ + "Src/Client/Tiles/TextTile/textTile.html";